import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { CommonModule } from '@angular/common';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { PendingMessageService } from './services/pending-message.service';
import { LoadingComponent } from './components/loading/loading.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, MatSnackBarModule, LoadingComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <router-outlet></router-outlet>
    <app-loading></app-loading>
  `
})
export class App implements OnInit {
  title = 'Plataforma-Digital';

  constructor(
    private router: Router,
    private titleService: Title,
    private snackBar: MatSnackBar,
    private pendingMessage: PendingMessageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        const currentUrl = event.urlAfterRedirects || event.url;

        if (currentUrl.startsWith('/reports')) {
          this.titleService.setTitle('Plataforma de Reports');
        } else {
          this.titleService.setTitle('Plataforma de Leads');
        }

        const msg = this.pendingMessage.consume();
        if (msg) {
          this.snackBar.open(msg, 'Fechar', {
            duration: 6000,
            panelClass: 'error-snackbar',
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      });
    }
  }
}
